import { useMemo, useState } from "react";
import { authApi } from "../../services/apiClient";
import { APP_FONT_FAMILY } from "../../shared/theme";

export default function ResetPasswordPage() {
  const params = useMemo(() => new URLSearchParams(window.location.search), []);
  const token = params.get("token") || "";
  const email = params.get("email") || "";

  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const goLogin = () => {
    const path = window.location.pathname || "/";
    window.location.href = path;
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setMessage("");
    try {
      const data = await authApi.resetPassword({
        email: email.trim(),
        token,
        password,
        password_confirmation: passwordConfirmation,
      });
      setMessage(data?.message || "Mot de passe mis à jour.");
      setTimeout(() => {
        goLogin();
      }, 2000);
    } catch (err) {
      setError(err.message || "Reinitialisation impossible.");
    } finally {
      setLoading(false);
    }
  };

  if (!token || !email) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: APP_FONT_FAMILY, padding: 24 }}>
        <div style={{ maxWidth: 420, textAlign: "center" }}>
          <p style={{ color: "#991b1b", marginBottom: 16 }}>Lien incomplet ou expiré.</p>
          <button type="button" onClick={goLogin} style={{ padding: "10px 18px", borderRadius: 8, border: "none", background: "#2563eb", color: "#fff", fontWeight: 700, cursor: "pointer" }}>
            Retour à la connexion
          </button>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f9fafb",
        fontFamily: APP_FONT_FAMILY,
        padding: 20,
      }}
    >
      <form
        onSubmit={submit}
        style={{
          width: "100%",
          maxWidth: 420,
          background: "#fff",
          borderRadius: 12,
          padding: 28,
          border: "1px solid #e4e7ec",
          boxShadow: "0 1px 3px rgba(16,24,40,0.08)",
        }}
      >
        <h1 style={{ margin: 0, fontSize: 22, color: "#111827" }}>Nouveau mot de passe</h1>
        <p style={{ marginTop: 8, marginBottom: 20, color: "#6b7280", fontSize: 13 }}>
          Compte : <strong>{email}</strong>
        </p>

        <label style={{ display: "block", fontSize: 12, color: "#374151", marginBottom: 6 }}>Nouveau mot de passe</label>
        <input
          type="password"
          required
          minLength={8}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #d1d5db", marginBottom: 12 }}
        />

        <label style={{ display: "block", fontSize: 12, color: "#374151", marginBottom: 6 }}>Confirmation</label>
        <input
          type="password"
          required
          minLength={8}
          value={passwordConfirmation}
          onChange={(e) => setPasswordConfirmation(e.target.value)}
          style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #d1d5db", marginBottom: 14 }}
        />

        {error && (
          <div style={{ marginBottom: 12, padding: "10px 12px", background: "#fef2f2", color: "#991b1b", border: "1px solid #fecaca", borderRadius: 8, fontSize: 12 }}>
            {error}
          </div>
        )}

        {message && (
          <div style={{ marginBottom: 12, padding: "10px 12px", background: "#ecfdf3", color: "#065f46", border: "1px solid #bbf7d0", borderRadius: 8, fontSize: 12 }}>
            {message}
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          style={{
            width: "100%",
            padding: "11px 12px",
            borderRadius: 8,
            border: "none",
            background: "#2563eb",
            color: "#fff",
            fontWeight: 700,
            cursor: "pointer",
            opacity: loading ? 0.7 : 1,
            marginBottom: 10,
          }}
        >
          {loading ? "Enregistrement..." : "Enregistrer le mot de passe"}
        </button>
        <button
          type="button"
          onClick={goLogin}
          style={{
            width: "100%",
            padding: "9px 12px",
            borderRadius: 8,
            border: "1px solid #d1d5db",
            background: "#fff",
            color: "#374151",
            fontWeight: 600,
            cursor: "pointer",
            fontSize: 13,
          }}
        >
          Retour à la connexion
        </button>
      </form>
    </div>
  );
}
